import React from 'react';

const createBladeIcon = (isActive, stockStatus = 'healthy') => {
  let color;
  if (!isActive) {
    color = "#9E9E9E"; // Gray for inactive
  } else {
    switch (stockStatus) {
      case 'critical':
        color = "#f44336"; // Red for critical (< 90%)
        break;
      case 'warning':
        color = "#ff9800"; // Orange for warning (< 95%)
        break;
      case 'healthy':
      default:
        color = "#4CAF50"; // Green for healthy (>= 95%)
        break;
    }
  }

  return `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <!-- Outer Hexagon -->
      <path d="M12 2L2 7V17L12 22L22 17V7L12 2Z" fill="${color}" stroke="white" stroke-width="1"/>
      
      <!-- Inner Hexagon Pattern -->
      <path d="M12 6L7 8.5V15.5L12 18L17 15.5V8.5L12 6Z" fill="white" fill-opacity="0.5"/>
      
      <!-- Server Rack Lines -->
      <path d="M9 10L15 10M9 14L15 14" stroke="white" stroke-width="1"/>
      
      <!-- Center Dot -->
      <circle cx="12" cy="12" r="1" fill="white"/>
      
      <!-- Fan Blades -->
      <g>
        <path d="M12 8L14 10L12 12L10 10L12 8Z" fill="white" fill-opacity="0.8"/>
        <path d="M16 12L14 14L12 12L14 10L16 12Z" fill="white" fill-opacity="0.8"/>
        <path d="M12 16L10 14L12 12L14 14L12 16Z" fill="white" fill-opacity="0.8"/>
        <path d="M8 12L10 10L12 12L10 14L8 12Z" fill="white" fill-opacity="0.8"/>
      </g>
    </svg>
  `;
};

export default createBladeIcon; 